import axios, { AxiosError } from 'axios';
import { RateLimiterRes } from 'rate-limiter-flexible';

export const isZmyleError = (error?: unknown): error is ZmyleError => {
  if (!error || typeof error !== 'object') return false;

  return (
    'errorId' in error &&
    'status' in error &&
    'errorMsg' in error &&
    ('occurredAt' in error || 'occuredAt' in error)
  );
};

export const isZmyleTransactionIntent = (
  data: unknown,
): data is ZmyleTransactionIntent => {
  if (!data || typeof data !== 'object') return false;

  return (
    'transactionIntentId' in data &&
    'expiresAt' in data &&
    'statementDescriptor' in data
  );
};

export const isAxiosError = (error?: unknown): error is AxiosError => {
  return axios.isAxiosError(error);
};

export interface AppRateLimiterResponse {
  reason: unknown; // api error that triggered the rate limiter
  rateLimiter: {
    giftcardId?: RateLimiterRes | null;
    clientIP: RateLimiterRes | null;
  };
}

export const isAppRateLimiterResponse = (
  payload?: unknown,
): payload is AppRateLimiterResponse => {
  if (!payload || typeof payload !== 'object') return false;

  return 'reason' in payload && 'rateLimiter' in payload;
};
